export default __webpack_public_path__ + "static/media/order.212b5b78.svg";